module.exports = __webpack_public_path__ + "media/brands/saurer-00984cdd.png";